import React, { useEffect, useState } from 'react';
import { Modal } from 'bootstrap';
import { deleteSupervisor, getSupervisors, updateSupervisorUser } from '../../services/supervisors';
import { MessageWithIcon } from '../common/messagePopup';
import { useNavigate } from 'react-router-dom';

const SupervisorList = () => {
  const navigate = useNavigate();

  const [supervisors, setSupervisors] = useState([]);
  const [selectedSupervisor, setSelectedSupervisor] = useState(null);
  const [form, setForm] = useState({
    username: '',
    email: '',
    phone: '',
    employee_code: '',
    password: '',
  });

  useEffect(() => {
    fetchSupervisors();
  }, []);

  const fetchSupervisors = async () => {
    try {
      const res = await getSupervisors('/supervisor/');
      setSupervisors(res || []);
    } catch (err) {
      console.error('Failed to fetch drivers', err);
    }
  };

  const openEditModal = supervisor => {
    setSelectedSupervisor(supervisor);
    setForm({
      username: supervisor.user?.username || '',
      email: supervisor.email || '',
      phone: supervisor.phone || '',
      employee_code: supervisor.user?.employee_code || '',
      password: '',
      supervisor_id: supervisor.user.id,
    });
    const modal = new Modal(document.getElementById('editModal'));
    modal.show();
  };

  const openDeleteModal = supervisor => {
    setSelectedSupervisor(supervisor);
    const modal = new Modal(document.getElementById('deleteModal'));
    modal.show();
  };

  const handleCloseModal = modaltype => {
    const modalEl = document.getElementById(modaltype);
    const modal = Modal.getInstance(modalEl);
    modal?.hide();
  };

  const handleSave = async () => {
    // Send update API call here using selectedDriver.id and form
    console.log('Saving', form);
    editUser(form);
    //  fetchSupervisors();
    //  new Modal(document.getElementById('editModal')).hide();
  };

  const editUser = input => {
    updateSupervisorUser(input)
      .then(response => {
        try {
          if (response?.account) {
            handleCloseModal('editModal');
            MessageWithIcon('User Updated! ' + response.message, 'success');
            navigate('/supervisor/list');
          }
        } catch (err) {
          MessageWithIcon(`Update Driver Error: ${err}`, 'error');
        }
      })
      .catch(err => {
        MessageWithIcon(err.data.error, 'error');
      });
  };

  const handleDelete = async () => {
    // Send delete API call here using selectedDriver.id
    console.log('Deleting', selectedSupervisor);
    deleteUser(selectedSupervisor);
    // fetchSupervisors();
    // new Modal(document.getElementById('deleteModal')).hide();
  };

  const deleteUser = input => {
    deleteSupervisor(input.user.id)
      .then(response => {
        try {
          if (response?.message) {
            handleCloseModal('deleteModal');
            MessageWithIcon('User Deleted! ' + response.message, 'success');
            //navigate('/supervisor/list');
            fetchSupervisors();
          }
        } catch (err) {
          MessageWithIcon(`Delete Driver Error: ${err}`, 'error');
        }
      })
      .catch(err => {
        MessageWithIcon(err.data.error, 'error');
      });
  };

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h4>Supervisors List</h4>
          <p className="mb-0">Manage Supervisor</p>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/supervisor/add')}>
          + Add Supervisor
        </button>
      </div>

      <div className="card p-3">
        <div className="table-responsive">
          <table className="table table-bordered table-striped align-middle">
            <thead className="table-light">
              <tr>
                <th>
                  Supervisor
                  <br />
                  Phone
                  <br />
                  Code
                </th>

                <th>Supervisor Email</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {supervisors.map((d, index) => (
                <tr key={index}>
                  <td>
                    {d.user?.username}
                    <br />
                    {d.phone}
                    <br />
                    {d.user?.employee_code}
                  </td>
                  <td>{d?.email}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => openEditModal(d)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => openDeleteModal(d)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {supervisors.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center text-muted">
                    No drivers found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Edit Modal */}
      <div
        className="modal fade"
        id="editModal"
        tabIndex="-1"
        aria-labelledby="editModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="editModalLabel">
                Edit Supervisor
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              {['username', 'email', 'phone', 'employee_code', 'password'].map(field => (
                <div className="mb-3" key={field}>
                  <label className="form-label text-capitalize">{field.replace('_', ' ')}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={form[field]}
                    onChange={e => setForm({ ...form, [field]: e.target.value })}
                  />
                </div>
              ))}
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={handleSave}>
                Update
              </button>
              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => handleCloseModal('editModal')}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      <div
        className="modal fade"
        id="deleteModal"
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteModalLabel">
                Delete Supervisor
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              Are you sure you want to delete <strong>{selectedSupervisor?.user?.username}</strong>?
            </div>
            <div className="modal-footer">
              <button className="btn btn-danger" onClick={handleDelete}>
                Delete
              </button>
              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => handleCloseModal('deleteModal')}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SupervisorList;
